<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Till Checkers Queue",
    meta: [{ name: "Till Checkers Queue", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Till Checkers Queue",
      items: [
        {
          text: "Till",
          href: "/"
        },
        {
          text: "Till Checkers Queue",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Till Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <TillCheckersQueueTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
